

import { useContext, useRef, useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { AuthContext } from "./AuthContext"
import "./loginstyle.css"
import { motion } from "framer-motion"

function Header() {
  return (
    <div className="text-center">
      <h2 className="mt-2 text-3xl font-extrabold text-red-800">Welcome to AIAT</h2>
    </div>
  )
}

function Footer({ handleGuestLogin }) {
  return (
    <>
      <div className="mt-6 text-center">
        <div className="flex items-center justify-center space-x-4">
          <p className="text-sm text-gray-800 bg-white bg-opacity-50 rounded-lg px-7 py-2">
            Don't have an account?
            <br />
            <a
              href="/register"
              className="mt-1 inline-block font-medium text-red-700 hover:text-red-600 underline"
            >
              Sign up now
            </a>
          </p>
          <div className="h-4 w-px bg-gray-300"></div>
          <p className="text-sm text-gray-600 bg-white bg-opacity-50 rounded-lg px-8 py-3 hover:bg-opacity-100">
            <a href="#" className="font-medium text-gray-800 hover:text-black" onClick={handleGuestLogin}>
              Guest 
              <br />
              Access
            </a>
          </p>
        </div>
      </div>
    </>
  )
}

function LoginTable({ handleLogin, handleGuestLogin, error }) {
  return (
    <>
      <Header />
      <InputField handleLogin={handleLogin} error={error} />
      <Footer handleLogin={handleLogin} handleGuestLogin={handleGuestLogin} />
    </>
  )
}

function TOSAndPP({ agreeToTerms, setAgreeToTerms, tosError, setTosError }) {
  const checkboxRef = useRef(null)
  return (
    <div className="mt-5 relative">
      <div className="flex items-center">
        <input
          ref={checkboxRef}
          id="agree-terms"
          name="agree-terms"
          type="checkbox"
          className="h-4 w-4 text-red-700 focus:ring-red-600 border-gray-300 rounded"
          checked={agreeToTerms}
          onChange={(e) => {
            setAgreeToTerms(e.target.checked)
            if (e.target.checked) {
              setTosError("")
            }
          }}
        />
        <label htmlFor="agree-terms" className="ml-2 block text-sm text-gray-400">
          By using AIAT, you agree to our{" "}
          <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-700">
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-gray-700"
          >
            Privacy Policy
          </a>
        </label>
      </div>
      {tosError && (
        <div className="absolute top-[-5rem] left-0 w-full p-3 bg-yellow-50 rounded-lg flex items-start relative">
          <div className="absolute left-4 -bottom-2">
            <div className="w-4 h-4 bg-yellow-50 transform rotate-45"></div>
          </div>
          <i className="fas fa-exclamation-circle text-yellow-600 mt-1 mr-2"></i>
          <span className="text-gray-700 text-sm">{tosError}</span>
        </div>
      )}
    </div>
  )
}

function InputField({ handleLogin, error }) {
  const { email, password, rememberMe, setEmail, setPassword, setRememberMe } = useContext(AuthContext)
  const [emailError, setEmailError] = useState("")
  const [passwordError, setPasswordError] = useState("")

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return re.test(email)
  }

  const handlePasswordChange = (e) => {
    const value = e.target.value
    setPassword(value)
    if (value === "") {
      setPasswordError("Password is required")
    } else {
      setPasswordError("")
    }
  }

  return (
    <div>
      {error ? (
        <div className="appearance-none rounded relative block w-full px-4 py-3 border border-red-600 placeholder-gray-500 text-red-600 rounded-md focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 text-sm mb-2 bg-red-50">
          <i className="fa-solid fa-times-circle mr-2 text-red-600"></i>
          {error}
        </div>
      ) : null}
      <form className="mt-2 space-y-6" onSubmit={handleLogin} noValidate>
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <label htmlFor="email-address" className="sr-only">
              Email Address
            </label>
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="appearance-none rounded relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 text-sm mb-2"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              // onChange={handleEmailChange}
            />
          </div>
          <div>
            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              className="appearance-none rounded relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 text-sm"
              placeholder="Password"
              value={password}
              // onChange={(e) => setPassword(e.target.value)}
              onChange={handlePasswordChange}
            />
          </div>
        </div>
        <div className="flex items-center justify-between ">
          <div className="flex items-center mt-[-1rem]">
            <input
              id="remember-me"
              name="remember-me"
              type="checkbox"
              className="h-4 w-4 text-red-700 focus:ring-red-600 border-gray-300 rounded"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
              Remember me
            </label>
          </div>
          <div className="text-sm mt-[-1rem]">
            <a href="/forgot-password" className="font-medium text-red-700 hover:text-red-600">
              Forgot password?
            </a>
          </div>
        </div>
        <div>
          <button
            type="submit"
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-800 hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 rounded-md whitespace-nowrap transition-all duration-300 transform hover:scale-105"
          >
            Login
          </button>
        </div>
      </form>
    </div>
  )
}

// Typewriter component for animated text
function Typewriter({ text, delay = 50, className = "", onComplete = () => {} }) {
  const [displayText, setDisplayText] = useState("")
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + text[currentIndex])
        setCurrentIndex((prev) => prev + 1)
      }, delay)

      return () => clearTimeout(timeout)
    } else if (!isComplete) {
      setIsComplete(true)
      onComplete()
    }
  }, [currentIndex, delay, text, isComplete, onComplete])

  return (
    <span className={`${className} inline-block`}>
      {displayText}
      <span className="animate-pulse-fast">|</span>
    </span>
  )
}

// Feature animation component
function FeatureAnimation() {
  const features = [
    {
      name: "Course Helper",
      icon: "fas fa-book-open",
      color: "bg-red-600",
      description: "Access organized course materials and comprehensive study guides",
      typewriterTexts: ["Topic: Calculus", "Generating study materials...", "Creating practice problems..."],
    },
    {
      name: "Plot Generator",
      icon: "fas fa-chart-line",
      color: "bg-red-700",
      description: "Create interactive mathematical plots and visualizations",
      typewriterTexts: ["Pointwise Function", "Plotting function...", "3D visualization..."],
    },
    {
      name: "Chatbox",
      icon: "fas fa-comments",
      color: "bg-red-800",
      description: "Get instant help with concepts and step-by-step solutions",
      typewriterTexts: [
        "User: How do I solve this integral?",
        "AIAT: Let's break it down step by step...",
        "User: Thanks, that makes sense now!",
      ],
    },
    {
      name: "Calculator",
      icon: "fas fa-calculator",
      color: "bg-red-900",
      description: "Perform advanced calculations with our scientific calculator",
      typewriterTexts: ["Integrate x e^x", "Computing...", "Result: ..."],
    },
    {
      name: "Exam Grader",
      icon: "fas fa-check-square",
      color: "bg-red-800",
      description: "Upload and automatically grade your exams with AI",
      typewriterTexts: [
        "Analyzing student response...",
        "Comparing with model answer...",
        "Score: 85% - Good understanding!",
      ],
    },
    {
      name: "Question Search",
      icon: "fas fa-search",
      color: "bg-red-700",
      description: "Find practice questions from thousands of past papers",
      typewriterTexts: [
        "Searching: 'differential equations'",
        "Found 128 questions...",
        "Filter by Exam Board...",
      ],
    },
  ]

  const [activeIndex, setActiveIndex] = useState(0)
  const [hoveredCard, setHoveredCard] = useState(null)
  const [typewriterIndex, setTypewriterIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      if (hoveredCard === null) {
        setActiveIndex((current) => (current + 1) % features.length)
        setTypewriterIndex(0) // Reset typewriter index when changing features
      }
    }, 8000) // Longer display time to allow for typewriter effect
    return () => clearInterval(interval)
  }, [features.length, hoveredCard])

  // Handle typewriter completion
  const handleTypewriterComplete = () => {
    if (typewriterIndex < features[activeIndex].typewriterTexts.length - 1) {
      setTimeout(() => {
        setTypewriterIndex((prev) => prev + 1)
      }, 1000) // Delay before starting the next line
    }
  }

  return (
    <div className="h-full w-full flex items-center justify-center overflow-hidden">
      <div className="relative w-full h-full flex flex-col justify-between py-8">
        {/* Background elements */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-red-600/30 blur-3xl animate-pulse-slow"></div>
          <div className="absolute top-2/3 right-1/3 w-80 h-80 rounded-full bg-red-800/20 blur-3xl animate-pulse-slow-2"></div>
          <div className="absolute bottom-1/4 left-1/2 w-72 h-72 rounded-full bg-red-700/25 blur-3xl animate-pulse-slow-3"></div>
        </div>

        {/* AIAT Logo */}
        <div className="relative text-center mb-2">
          <h1 className="text-4xl font-bold text-white">
            <span className="text-white">AIAT</span>
            <span className="text-red-400"> Learning</span>
          </h1>
          <p className="text-gray-300 mt-1">Your Intelligent Academic Companion</p>
        </div>

        {/* Feature cards - taking most of the height */}
        <div className="relative flex-grow flex items-center justify-center px-4">
          <div className="relative w-full max-w-md h-[80vh] max-h-[650px]">
            {features.map((feature, index) => (
              <div
                key={feature.name}
                className={`absolute inset-0 w-full h-full bg-black/30 backdrop-blur-lg rounded-xl p-4 shadow-2xl border border-red-500/20 transition-all duration-1000 ease-in-out flex flex-col group cursor-pointer ${
                  index === activeIndex
                    ? "opacity-100 transform translate-y-0 scale-100 z-10"
                    : "opacity-0 transform translate-y-8 scale-95 -z-10"
                }`}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="flex items-center mb-2">
                  <div
                    className={`w-12 h-12 rounded-full ${feature.color} flex items-center justify-center text-white transition-transform duration-300 group-hover:scale-110`}
                  >
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <h3 className="ml-4 text-2xl font-bold text-white group-hover:text-red-300 transition-colors duration-300">
                    {feature.name}
                  </h3>
                </div>
                <p className="text-gray-300 mb-3 group-hover:text-white transition-colors duration-300">
                  {feature.description}
                </p>

                {/* Feature-specific illustration - BIGGER size */}
                <div className="flex-grow bg-black/20 rounded-lg flex items-center justify-center p-2 overflow-hidden border border-red-500/10 group-hover:border-red-500/30 transition-all duration-300 group-hover:shadow-[0_0_15px_rgba(239,68,68,0.3)]">
                  {feature.name === "Course Helper" && (
                    <div className="flex space-x-4 h-full w-full items-center">
                      <div className="w-1/3 h-full bg-red-500/50 rounded animate-pulse-slow shadow-[0_0_15px_rgba(239,68,68,0.5)]"></div>
                      <div className="space-y-4 w-2/3">
                        <div className="w-full h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]">
                          <div className="p-1 h-full flex items-center">
                            {index === activeIndex && typewriterIndex === 0 && (
                              <Typewriter
                                text={feature.typewriterTexts[0]}
                                className="text-white text-sm font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className="w-5/6 h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.2s" }}
                        >
                          <div className="p-1 h-full flex items-center">
                            {index === activeIndex && typewriterIndex === 1 && (
                              <Typewriter
                                text={feature.typewriterTexts[1]}
                                className="text-white text-sm font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className="w-4/6 h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.4s" }}
                        >
                          <div className="p-1 h-full flex items-center">
                            {index === activeIndex && typewriterIndex === 2 && (
                              <Typewriter
                                text={feature.typewriterTexts[2]}
                                className="text-white text-sm font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className="w-full h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.6s" }}
                        ></div>
                        <div
                          className="w-3/6 h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.8s" }}
                        ></div>
                        <div
                          className="w-5/6 h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "1s" }}
                        ></div>
                        <div
                          className="w-4/6 h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "1.2s" }}
                        ></div>
                        <div
                          className="w-full h-6 bg-red-500/50 rounded animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "1.4s" }}
                        ></div>
                      </div>
                    </div>
                  )}

                  {feature.name === "Plot Generator" && (
                    <div className="relative w-full h-full flex flex-col items-center justify-center">
                      <div className="w-full mb-4 p-2">
                        <div className="bg-red-500/30 rounded-lg p-2 mb-2 shadow-[0_0_10px_rgba(239,68,68,0.5)]">
                          <div className="flex items-center">
                            <span className="text-red-300 mr-2">f(x) =</span>
                            {index === activeIndex && typewriterIndex === 0 && (
                              <Typewriter
                                text={feature.typewriterTexts[0].replace("f(x) = ", "")}
                                className="text-white font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div className="bg-red-500/20 rounded-lg p-2 shadow-[0_0_10px_rgba(239,68,68,0.5)]">
                          {index === activeIndex && typewriterIndex >= 1 && (
                            <Typewriter
                              text={feature.typewriterTexts[typewriterIndex]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>

                      <div className="relative flex-grow w-full">
                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-red-500/50"></div>
                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-500/50"></div>

                        <div className="w-full h-full relative">
                          <div className="absolute top-1/4 left-0 right-0 h-px bg-red-500/20"></div>
                          <div className="absolute top-2/4 left-0 right-0 h-px bg-red-500/20"></div>
                          <div className="absolute top-3/4 left-0 right-0 h-px bg-red-500/20"></div>

                          <div className="absolute left-1/4 top-0 bottom-0 w-px bg-red-500/20"></div>
                          <div className="absolute left-2/4 top-0 bottom-0 w-px bg-red-500/20"></div>
                          <div className="absolute left-3/4 top-0 bottom-0 w-px bg-red-500/20"></div>

                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-full h-full relative">
                              <div className="absolute h-6 w-6 bg-red-600 rounded-full top-[10%] left-[10%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"></div>
                              <div
                                className="absolute h-6 w-6 bg-red-600 rounded-full top-[30%] left-[25%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.3s" }}
                              ></div>
                              <div
                                className="absolute h-6 w-6 bg-red-600 rounded-full top-[50%] left-[40%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.6s" }}
                              ></div>
                              <div
                                className="absolute h-6 w-6 bg-red-600 rounded-full top-[70%] left-[55%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.9s" }}
                              ></div>
                              <div
                                className="absolute h-6 w-6 bg-red-600 rounded-full top-[90%] left-[70%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "1.2s" }}
                              ></div>
                              <div
                                className="absolute h-6 w-6 bg-red-600 rounded-full top-[80%] left-[85%] animate-bounce shadow-[0_0_10px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "1.5s" }}
                              ></div>

                              <div className="absolute h-2 bg-red-500 top-[10%] left-[10%] w-[15%] transform rotate-[15deg] origin-left animate-pulse-fast shadow-[0_0_5px_rgba(239,68,68,0.8)]"></div>
                              <div
                                className="absolute h-2 bg-red-500 top-[30%] left-[25%] w-[15%] transform rotate-[25deg] origin-left animate-pulse-fast shadow-[0_0_5px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.2s" }}
                              ></div>
                              <div
                                className="absolute h-2 bg-red-500 top-[50%] left-[40%] w-[15%] transform rotate-[35deg] origin-left animate-pulse-fast shadow-[0_0_5px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.4s" }}
                              ></div>
                              <div
                                className="absolute h-2 bg-red-500 top-[70%] left-[55%] w-[15%] transform rotate-[25deg] origin-left animate-pulse-fast shadow-[0_0_5px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.6s" }}
                              ></div>
                              <div
                                className="absolute h-2 bg-red-500 top-[90%] left-[70%] w-[15%] transform rotate-[-15deg] origin-left animate-pulse-fast shadow-[0_0_5px_rgba(239,68,68,0.8)]"
                                style={{ animationDelay: "0.8s" }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {feature.name === "Chatbox" && (
                    <div className="w-full h-full flex flex-col justify-center space-y-8">
                      <div className="flex justify-start">
                        <div className="bg-red-500/40 rounded-lg p-4 max-w-[80%] transition-all duration-300 transform animate-float-1 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                          {index === activeIndex && typewriterIndex === 0 && (
                            <Typewriter
                              text={feature.typewriterTexts[0]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <div className="bg-red-700/40 rounded-lg p-4 max-w-[80%] transition-all duration-300 transform animate-float-2 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                          {index === activeIndex && typewriterIndex === 1 && (
                            <Typewriter
                              text={feature.typewriterTexts[1]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                      <div className="flex justify-start">
                        <div className="bg-red-500/40 rounded-lg p-4 max-w-[80%] transition-all duration-300 transform animate-float-3 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                          {index === activeIndex && typewriterIndex === 2 && (
                            <Typewriter
                              text={feature.typewriterTexts[2]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {feature.name === "Calculator" && (
                    <div className="flex flex-col w-full h-full p-4">
                      <div className="h-20 bg-red-500/40 rounded mb-4 flex items-end justify-end p-3 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        <div className="w-full h-full flex flex-col justify-between">
                          <div className="h-1/2 flex items-center px-2">
                            {index === activeIndex && typewriterIndex === 0 && (
                              <Typewriter
                                text={feature.typewriterTexts[0]}
                                className="text-white font-mono text-sm"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                          <div className="h-1/2 flex items-center justify-between px-2">
                            {index === activeIndex && typewriterIndex >= 1 && (
                              <Typewriter
                                text={feature.typewriterTexts[typewriterIndex]}
                                className="text-white font-mono text-sm"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-4 gap-4 flex-grow">
                        {[...Array(16)].map((_, i) => (
                          <div
                            key={i}
                            className="aspect-square bg-red-500/40 rounded-full flex items-center justify-center text-white text-2xl transition-all duration-300 transform hover:scale-110 cursor-pointer animate-pop shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                            style={{ animationDelay: `${i * 0.05}s` }}
                          >
                            {i < 10 ? i : ["+", "-", "×", "="][i - 10]}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {feature.name === "Exam Grader" && (
                    <div className="w-full h-full flex flex-col justify-center space-y-8 p-4">
                      <div className="w-full bg-red-500/40 rounded p-3 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        {index === activeIndex && typewriterIndex === 0 && (
                          <Typewriter
                            text={feature.typewriterTexts[0]}
                            className="text-white font-mono"
                            onComplete={handleTypewriterComplete}
                          />
                        )}
                      </div>
                      <div className="w-full h-14 bg-red-500/40 rounded flex items-center overflow-hidden shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        <div className="h-full w-3/4 bg-red-600/80 rounded-l animate-pulse-slow shadow-inner"></div>
                        <div className="ml-4 text-white text-xl animate-pulse-fast">
                          {index === activeIndex && typewriterIndex === 1 && (
                            <Typewriter
                              text={feature.typewriterTexts[1]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                      <div className="w-full h-14 bg-red-500/40 rounded flex items-center overflow-hidden shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        <div className="h-full w-2/3 bg-red-500/80 rounded-l animate-pulse-slow-3 shadow-inner"></div>
                        <div className="ml-4 text-white text-xl animate-pulse-fast">
                          {index === activeIndex && typewriterIndex === 2 && (
                            <Typewriter
                              text={feature.typewriterTexts[2]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {feature.name === "Question Search" && (
                    <div className="w-full h-full flex flex-col justify-center space-y-6 p-2">
                      <div className="w-full h-16 bg-red-500/40 rounded flex items-center px-4 shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        <i className="fas fa-search text-red-300 mr-3 text-2xl animate-pulse-fast"></i>
                        <div className="flex-grow">
                          {index === activeIndex && typewriterIndex === 0 && (
                            <Typewriter
                              text={feature.typewriterTexts[0]}
                              className="text-white font-mono"
                              onComplete={handleTypewriterComplete}
                            />
                          )}
                        </div>
                      </div>
                      <div className="space-y-5 flex-grow">
                        <div className="w-full h-12 bg-red-500/30 rounded p-3 flex items-center animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]">
                          <div className="w-6 h-6 rounded-full bg-red-400 mr-3 animate-pulse-slow"></div>
                          <div className="flex-grow">
                            {index === activeIndex && typewriterIndex === 1 && (
                              <Typewriter
                                text={feature.typewriterTexts[1]}
                                className="text-white font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className="w-full h-12 bg-red-500/30 rounded p-3 flex items-center animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.2s" }}
                        >
                          <div className="w-6 h-6 rounded-full bg-red-500 mr-3 animate-pulse-slow-2"></div>
                          <div className="flex-grow">
                            {index === activeIndex && typewriterIndex === 2 && (
                              <Typewriter
                                text={feature.typewriterTexts[2]}
                                className="text-white font-mono"
                                onComplete={handleTypewriterComplete}
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className="w-full h-12 bg-red-500/30 rounded p-3 flex items-center animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.4s" }}
                        >
                          <div className="w-6 h-6 rounded-full bg-red-600 mr-3 animate-pulse-slow-3"></div>
                          <div className="w-5/6 h-4 bg-red-500/60 rounded"></div>
                        </div>
                        <div
                          className="w-full h-12 bg-red-500/30 rounded p-3 flex items-center animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.6s" }}
                        >
                          <div className="w-6 h-6 rounded-full bg-red-700 mr-3 animate-pulse-slow"></div>
                          <div className="w-3/6 h-4 bg-red-500/60 rounded"></div>
                        </div>
                        <div
                          className="w-full h-12 bg-red-500/30 rounded p-3 flex items-center animate-move-left-right shadow-[0_0_10px_rgba(239,68,68,0.5)]"
                          style={{ animationDelay: "0.8s" }}
                        >
                          <div className="w-6 h-6 rounded-full bg-red-800 mr-3 animate-pulse-slow-2"></div>
                          <div className="w-4/6 h-4 bg-red-500/60 rounded"></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation dots */}
        <div className="relative flex justify-center space-x-3 mt-2">
          {features.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setActiveIndex(index)
                setTypewriterIndex(0) // Reset typewriter index when manually changing features
              }}
              className={`w-3 h-3 rounded-full transition-all duration-300 hover:scale-125 hover:bg-white ${
                index === activeIndex ? "bg-white scale-125" : "bg-white/30"
              }`}
              aria-label={`View feature ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

// Update the main Login component with unified background
export default function Login() {
  const { login, guestLogin, email, password, rememberMe } = useContext(AuthContext)
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || new URLSearchParams(location.search).get("redirect") || "/home"

  const [error, setError] = useState("")
  const [agreeToTerms, setAgreeToTerms] = useState(false)
  const [tosError, setTosError] = useState("")

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return re.test(email)
  }

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!email || !password) {
      setError("Email and password are required")
      return
    }

    if (!validateEmail(email)) {
      setError("Invalid Email or password")
      return
    }

    if (!agreeToTerms) {
      setTosError("Please read and check the relevant agreement.")
      return
    }

    try {
      const success = await login({ email, password, rememberMe })
      if (success) {
        navigate(from, { replace: true })
      } else {
        setError("Invalid email or password")
      }
    } catch (error) {
      setError("An error occurred during login")
      console.error("Login error:", error)
    }
  }

  const handleGuestLogin = async (e) => {
    e.preventDefault()
    try {
      const success = await guestLogin()
      if (success) {
        navigate(from, { replace: true })
      } else {
        setError("Guest login failed")
      }
    } catch (error) {
      setError("An error occurred during guest login")
      console.error("Guest login error:", error)
    }
  }

  // Update the main Login component to switch left and right sides and add a separator
  return (
    <div className="min-h-screen flex flex-col md:flex-row relative bg-gradient-to-br from-red-900 via-red-950 to-black">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-red-600/10 blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full bg-red-800/10 blur-3xl animate-pulse-slow-2"></div>
        <div className="absolute top-1/2 right-1/3 w-72 h-72 rounded-full bg-red-700/10 blur-3xl animate-pulse-slow-3"></div>
      </div>

      {/* Login form - now on the LEFT side */}
      <div className="z-10 md:w-1/2 min-h-screen flex flex-col justify-center items-center px-4 py-10">
        <motion.p
          className="mt-6 mb-6 text-center text-lg font-medium text-white max-w-xl mx-auto"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.5 }}
        >
          Sign up or log in to unlock powerful, free AI tools for your A-Level, IB, and AP courses!
        </motion.p>
        <div className="w-full max-w-[480px] h-auto space-y-6 bg-white/10 backdrop-blur-xl p-8 md:p-12 rounded-lg shadow-2xl border border-white/10">
          <LoginTable handleLogin={handleLogin} handleGuestLogin={handleGuestLogin} error={error} />
        </div>
        <TOSAndPP
          agreeToTerms={agreeToTerms}
          setAgreeToTerms={setAgreeToTerms}
          tosError={tosError}
          setTosError={setTosError}
        />
      </div>

      {/* Separator between sections */}
      <div className="hidden md:block w-px h-full bg-gradient-to-b from-transparent via-red-500/30 to-transparent absolute left-1/2 transform -translate-x-1/2 z-10"></div>

      {/* Animation section - now on the RIGHT side */}
      <div className="md:w-1/2 h-screen md:relative">
        <FeatureAnimation />
      </div>
    </div>
  )
}
